import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { User } from '../../models/login/user';
import { Observable } from 'rxjs/Rx';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import {MatSnackBarComponent} from "../mat-snack-bar/mat-snack-bar.component";
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: User;
  loginForm: FormGroup;
  display = 'none';
  emailaddress: string;
  pageName: any = {};
  public Username: string;
  ROOT_URL: string = "";
  loader: string = 'none';
  constructor(private route: ActivatedRoute, private router: Router, private loginService: LoginService, private form: FormBuilder, private snackBar: MatSnackBarComponent,
    private toastr: ToastrService) {
      let g: global = new global();
      this.ROOT_URL = g.getApiUrl();
  }

  ngOnInit(): void {
      this.loginForm = this.form.group({
          UserID: [''],
          Password: [''],
          Flag: ['getuserdata'],
          AssetCode: ['MCMT'],
          UserType: ['']
      });
  }

  authenticateUser(formData: any) {
    if(formData.value.UserID=='' && formData.value.Password==''){
      //this.snackBar.openSnackBar('Please enter User Name and Password.','Close','red-snackbar');
      this.toastr.error('Please enter User Name and Password.');
      return false;
    }
    if(formData.value.UserID==''){
      //this.snackBar.openSnackBar('Please enter User Name.','Close','red-snackbar');
      this.toastr.error('Please enter User Name.');
      return false;
    }
    if(formData.value.Password==''){
      //this.snackBar.openSnackBar('Please enter password.','Close','red-snackbar');
      this.toastr.error('Please enter password.');
      return false;
    }
    this.loader = 'block';
      this.loginService.authenticateUser(formData)
          .subscribe((resData: any) => {
              if (resData.status == true) {
                localStorage.setItem('mcmt_token',resData.data.token);
                localStorage.setItem('mcmt_user', resData.data);
                sessionStorage.setItem('mcmt_userId', resData.data.userID);
                localStorage.setItem('mcmt_userId', resData.data.userID);
                localStorage.setItem('mcmt_userName', resData.data.userName.trim());
                localStorage.setItem('mcmt_roleID', resData.data.roleID);
                localStorage.setItem('mcmt_roleCode', resData.data.roleName.trim());
                this.router.navigate(['/MCMaterial/Dashboard']);
                sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
                this.loader = 'none';
              } else if(resData.message == 'Invalid Username and Password!'){
                //this.snackBar.openSnackBar('Invalid Password.','Close','red-snackbar');
                this.toastr.error('Invalid Password.');  
                this.loader = 'none';
              }
              else{
                //this.snackBar.openSnackBar(resData.data.errorDescription,'Close','red-snackbar');
                this.toastr.error(resData.data.errorDescription);
                this.loader = 'none';
              }
          }
        );
  }

  showForgotPassword() {
    let url: any;
    if (this.ROOT_URL.indexOf('mcmaterial.uat.fmcone.in') !== -1)
            url = 'https://cmaster.uat.fmcone.in/ForgotPassword';
        else
            url = 'https://cmaster.fmcone.in/ForgotPassword';
    window.open(url, "_blank");
}

isValidUser(event: any) {
  let userID: string = event.target.value;
  if (userID != "") {
      this.loginService.validateUser(userID)
          .subscribe((response: any) => {
              if (response._body == "1") {
                //this.snackBar.openSnackBar('Your rights to login to the portal cannot be validated. Contact your administrator.','Close','red-snackbar');
                this.toastr.error('Your rights to login to the portal cannot be validated. Contact your administrator.');
                return false;
              }else{
                return true;
              }
          });
  }
}

}
